/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Why a billing period is not fully projected onto an entitlement.
 */
export type EntitlementProjectionFailure = typeof EntitlementProjectionFailure[keyof typeof EntitlementProjectionFailure];


export const EntitlementProjectionFailure = {
  overlap_conflict: 'overlap_conflict',
  expired_before_sync: 'expired_before_sync',
  linked_overlap: 'linked_overlap',
} as const;
